import { enableDevValidations, ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';

const licenseKey = __AG_GRID_LICENSE_KEY__.trim();

ModuleRegistry.registerModules([AllEnterpriseModule]);

if (process.env.NODE_ENV === 'development') {
  enableDevValidations();
}

if (licenseKey !== '') {
  LicenseManager.setLicenseKey(licenseKey);
}
